import * as types from "./mutationTypes";

export default {
  [types.SET_INTEGRATIONS](state, { integrations }) {
    state.integrations = integrations;
  },
  [types.CLEAR_INTEGRATIONS](state) {
    state.integrations = [];
  },
  [types.SET_INTEGRATION](state, { integration }) {
    state.integration = integration;
  },
  [types.CLEAR_INTEGRATION](state) {
    state.integration = [];
  },
  [types.SET_INTEGRATION_ID](state, { integrationId }) {
    state.integrationId = integrationId;
  },
  [types.CLEAR_INTEGRATION_ID](state) {
    state.integrationId = 0;
  },
  [types.SET_TOKEN](state, { token }) {
    state.integration.token = token;
  },
  [types.TOGGLE_INTEGRATION](state, { enable }) {
    state.integration.enabled = enable;
  },
  [types.SET_URL](state, { url }) {
    state.integration.url = url;
  },
  [types.SET_NAME](state, { name }) {
    state.integration.name = name;
  },
  [types.SET_PHONE](state, { phone }) {
    state.integration.phone = phone;
  },
  [types.SET_SENDER_KEY](state, { senderKey }) {
    state.integration.sender_key = senderKey;
  },
  [types.SET_NAMESPACE](state, { namespace }) {
    state.integration.namespace = namespace;
  },
  [types.SET_WEBHOOK_URL](state, { webhookUrl }) {
    state.integration.webhook_url = webhookUrl;
  },
  [types.SET_WORKSPACE_ID](state, { workspaceId }) {
    state.integration.workspace_id = workspaceId;
  },
  [types.SET_BROKER](state, { broker }) {
    state.integration.broker = broker;
  },
  [types.SET_DEFAULT](state, { isDefault }) {
    state.integration.default = isDefault;
  },
  [types.SET_SUBDOMAIN](state, { subdomain }) {
    state.integration.subdomain = subdomain;
  },
  [types.SET_EMAIL](state, { email }) {
    state.integration.email = email;
  },
  [types.SET_GROUPS](state, { groups }) {
    state.groups = groups;
  },
  [types.SET_IS_TOKEN_VALID](state, { valid }) {
    state.isTokenValid = valid;
  },
  [types.CLEAR_GROUPS](state) {
    state.groups = [];
  },
  [types.CLEAR_IS_TOKEN_VALID](state) {
    state.isTokenValid = false;
  },
  [types.SET_SEND_ATTRIBUTES](state, { sendAttributes }) {
    state.integration.send_attributes = sendAttributes;
  },
  [types.SET_EMAIL_INVITE_TEMPLATE_UUID](state, { templateUuid }) {
    state.integration.invite_template_uuid = templateUuid;
  },
  [types.SET_EMAIL_REMINDER_TEMPLATE_UUID](state, { templateUuid }) {
    state.integration.reminder_template_uuid = templateUuid;
  },
  [types.SET_LINKSMS_INVITE_TEMPLATE_UUID](state, { templateUuid }) {
    state.integration.linksms_invite_template_uuid = templateUuid;
  },
  [types.SET_LINKSMS_REMINDER_TEMPLATE_UUID](state, { templateUuid }) {
    state.integration.linksms_reminder_template_uuid = templateUuid;
  },
  [types.SET_THANKS_TEMPLATE_UUID](state, { templateUuid }) {
    state.integration.thanks_template_uuid = templateUuid;
  },
  [types.SET_EXPIRED_TEMPLATE_UUID](state, { templateUuid }) {
    state.integration.expired_template_uuid = templateUuid;
  },
  [types.SET_HEALTH_SCORE_NEGATIVE_GROUP](state, { group }) {
    state.integration.health_score.negative.group = group;
  },
  [types.SET_HEALTH_SCORE_POSITIVE_GROUP](state, { group }) {
    state.integration.health_score.positive.group = group;
  },
  [types.SET_HEALTH_SCORE_NEUTRAL_GROUP](state, { group }) {
    state.integration.health_score.neutral.group = group;
  },
  [types.SET_HEALTH_SCORE_NEGATIVE_TYPE](state, { type }) {
    state.integration.health_score.negative.type = type;
  },
  [types.SET_HEALTH_SCORE_POSITIVE_TYPE](state, { type }) {
    state.integration.health_score.positive.type = type;
  },
  [types.SET_HEALTH_SCORE_NEUTRAL_TYPE](state, { type }) {
    state.integration.health_score.neutral.type = type;
  },
  [types.SET_HEALTH_SCORE_NEGATIVE_PRIORITY](state, { priority }) {
    state.integration.health_score.negative.priority = priority;
  },
  [types.SET_HEALTH_SCORE_POSITIVE_PRIORITY](state, { priority }) {
    state.integration.health_score.positive.priority = priority;
  },
  [types.SET_HEALTH_SCORE_NEUTRAL_PRIORITY](state, { priority }) {
    state.integration.health_score.neutral.priority = priority;
  },
  [types.SET_HEALTH_SCORE_NEGATIVE_STATUS](state, { status }) {
    state.integration.health_score.negative.status = status;
  },
  [types.SET_HEALTH_SCORE_POSITIVE_STATUS](state, { status }) {
    state.integration.health_score.positive.status = status;
  },
  [types.SET_HEALTH_SCORE_NEUTRAL_STATUS](state, { status }) {
    state.integration.health_score.neutral.status = status;
  },
  [types.SET_HEALTH_SCORE_NEGATIVE_ENABLED](state, { enabled }) {
    state.integration.health_score.negative.enabled = enabled;
  },
  [types.SET_HEALTH_SCORE_POSITIVE_ENABLED](state, { enabled }) {
    state.integration.health_score.positive.enabled = enabled;
  },
  [types.SET_HEALTH_SCORE_NEUTRAL_ENABLED](state, { enabled }) {
    state.integration.health_score.neutral.enabled = enabled;
  },
  [types.SET_WHATSAPP_TEMPLATES](state, { templates }) {
    state.whatsappTemplates = templates;
  },
  [types.CLEAR_WHATSAPP_TEMPLATES](state) {
    state.whatsappTemplates = [];
  }
};
